import React, { useState } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import FormsyForm from 'formsy-react'
import _isFunction from 'lodash/isFunction'
import { getBoundActions } from '../../actions/index'
import { renamePlaylist } from '../../services/playlist/index'
import { H5 } from '../Heading/index'
import Button, { TYPES } from '../Button/index'
import Sherpa, { TYPE_SMALL_BLUE } from '../Sherpa/index'
import { TextInput } from '../FormInput.v2/index'
import FeedbackBox, { FEEDBACK_BOX_TYPES } from '../FeedbackBox/index'
import { addToasty } from '../../services/toasty/actions'

/**
 * TODO This component should be refactored to use graphql
 * once playlist update mutation is available.
 * Mutation methid should be implemented in the MyLIbraryPlaylist component
 * similar to handleDeleteClick and handleDeleteSubmit.
 * For now it uses REST endpoint to update playlist name
 * and fires the onRenameSuccess callback function to refetch playlistsList
 */

const MyLibraryPlaylistRenameModal = (props) => {
  const {
    auth,
    staticText,
    dismissModal,
    playlistName,
    playlistType,
    onRenameSuccess,
  } = props

  const [validForm, setValidForm] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState('')
  const errorKey = error === 'existing' ? 'createPlaylistNameError' : 'savePlaylistError'

  const onRenameSubmit = async (model) => {
    setProcessing(true)
    try {
      const playlistData = await renamePlaylist({
        auth,
        playlistName: model.playlistName,
        playlistType,
      })

      if (playlistData.existing) {
        setError('existing')
        setProcessing(false)
        return
      }

      if (_isFunction(onRenameSuccess)) {
        onRenameSuccess()
      }

      addToasty(staticText.get('savePlaylistSuccess'))
      dismissModal()
    } catch (e) {
      setError(e.message)
    } finally {
      setProcessing(false)
    }
  }

  return (
    <div className="multiple-playlists-rename-modal">
      <FormsyForm
        className="multiple-playlists-rename-modal__form"
        onValid={() => {
          setValidForm(true)
          setError('')
        }}
        onInvalid={() => setValidForm(false)}
        onValidSubmit={onRenameSubmit}
      >
        <H5 className="multiple-playlists-rename-modal__title">
          {staticText.get('renamePlaylist')}
        </H5>
        {error && <FeedbackBox type={FEEDBACK_BOX_TYPES.ERROR}>
          {staticText.get(errorKey)}
        </FeedbackBox>}
        <TextInput
          name="playlistName"
          label={staticText.get('playlistName')}
          validations={{
            maxLength: 40,
            differentName: (model) => model.playlistName !== playlistName,
          }}
          validationErrors={{
            maxLength: staticText.get('createPlaylistLengthError'),
            differentName: staticText.get('createPlaylistNameError'),
          }}
          maxLength={100}
          autocomplete="off"
          value={playlistName}
          required
        />
        {processing
          ? <Sherpa type={TYPE_SMALL_BLUE} />
          : <Button
            type={TYPES.PRIMARY}
            submit
            disabled={!validForm || processing}
            stacked
            className="multiple-playlists-rename-modal__button"
          >
            {staticText.get('savePlaylist')}
          </Button>
        }
      </FormsyForm>
    </div>
  )
}

MyLibraryPlaylistRenameModal.propTypes = {
  playlistName: PropTypes.string.isRequired,
  playlistType: PropTypes.string.isRequired,
  onRenameSuccess: PropTypes.func.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  dismissModal: PropTypes.func.isRequired,
}

export default connect(
  (state) => {
    return {
      auth: state.auth,
      staticText: state.staticText.getIn(['data', 'myLibraryPage', 'data'], Map()) || Map(),
    }
  },
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      dismissModal: actions.dialog.dismissModal,
      addToasty: actions.toasty.addToasty,
    }
  },
)(MyLibraryPlaylistRenameModal)
